export const district_data_bank = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "node/1964172923",
            "properties": {
                "amenity": "bank",
                "name": "Himalayan Bank",
                "id": "node/1964172923"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4301347,
                    27.6719355
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2133930069",
            "properties": {
                "addr:country": "NP",
                "addr:street": "nagarkot road",
                "addr:tole": "kamalbinayak",
                "amenity": "bank",
                "atm": "yes",
                "facility": "bank",
                "name": "Manakamana Development Bank",
                "name:en": "Mahalaxmi bikash bank",
                "opening_hours": "09:00-15:00",
                "operator:type": "private",
                "id": "node/2133930069"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4378554,
                    27.6776026
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2134525502",
            "properties": {
                "amenity": "bank",
                "atm": "yes",
                "name": "Machhapuchre Bank Limited",
                "id": "node/2134525502"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4373718,
                    27.6774392
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2134525503",
            "properties": {
                "addr:country": "NP",
                "addr:street": "nagarkot road",
                "amenity": "bank",
                "facility": "bank",
                "name": "नेपाल बैंक लिमिटेड",
                "name:en": "Nepal Bank Limited",
                "opening_hours": "Su-Fr 10:00-17:00",
                "operator:type": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/2134525503"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4373157,
                    27.6774165
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2183357019",
            "properties": {
                "addr:street": "khauma",
                "addr:tole": "khauma",
                "amenity": "bank",
                "name": "Citizen Bank",
                "opening_hours": "10:00-17:00",
                "operator": "private",
                "id": "node/2183357019"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4266975,
                    27.6723953
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2210859292",
            "properties": {
                "addr:place": "Bhaktapur 5",
                "amenity": "bank",
                "name": "Sunrise Bank",
                "operator": "Private",
                "id": "node/2210859292"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4311615,
                    27.6726403
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2214457990",
            "properties": {
                "amenity": "bank",
                "name": "Bank of Asia",
                "id": "node/2214457990"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4263353,
                    27.665892
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2214458009",
            "properties": {
                "amenity": "bank",
                "name": "GoodWill Finance",
                "id": "node/2214458009"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4297362,
                    27.6711782
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2214458029",
            "properties": {
                "amenity": "bank",
                "name": "Kist Bank",
                "id": "node/2214458029"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4264265,
                    27.6658635
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2214458032",
            "properties": {
                "amenity": "bank",
                "name": "Nepal SBI",
                "id": "node/2214458032"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4261851,
                    27.6659039
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2245133836",
            "properties": {
                "amenity": "bank",
                "atm": "yes",
                "name": "Himalayan Bank Pvt. Ltd",
                "id": "node/2245133836"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3633994,
                    27.6749154
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2245139975",
            "properties": {
                "addr:city": "Madyapur Thimi 3",
                "addr:place": "Gatthaghar",
                "amenity": "bank",
                "atm": "yes",
                "name": "Prime Bank Pvt. Ltd.",
                "opening_hours": "09:00-17:00",
                "wheelchair": "no",
                "id": "node/2245139975"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3749125,
                    27.6741109
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2249148039",
            "properties": {
                "addr:city": "Madyapur Thimi 3",
                "addr:street": "Kausaltar",
                "amenity": "bank",
                "atm": "yes",
                "name": "NIC Bank",
                "opening_hours": "10:00 - 15:00",
                "operator": "private",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/2249148039"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3646816,
                    27.6747967
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2249167450",
            "properties": {
                "amenity": "bank",
                "name": "KIST Bank",
                "id": "node/2249167450"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.365199,
                    27.6739749
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2342018466",
            "properties": {
                "amenity": "bank",
                "atm": "yes",
                "name": "Royal Merchant Banking and Finance Ltd.",
                "id": "node/2342018466"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3608362,
                    27.6744741
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2477486808",
            "properties": {
                "amenity": "bank",
                "name": "Rastriya Banijya",
                "id": "node/2477486808"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4277665,
                    27.6651675
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2479650330",
            "properties": {
                "amenity": "bank",
                "name": "Bhaktapur Agricultural Cooperative Society (BACSI)",
                "note": "public",
                "id": "node/2479650330"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4273064,
                    27.6663448
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/3136185728",
            "properties": {
                "amenity": "bank",
                "name": "kalash saving and credit cooperative society limited",
                "id": "node/3136185728"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3909259,
                    27.6907345
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/3803426949",
            "properties": {
                "amenity": "bank",
                "name": "ace development bank",
                "id": "node/3803426949"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3648482,
                    27.6742278
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4235760489",
            "properties": {
                "amenity": "bank",
                "name": "Nepal Banijya Bank",
                "id": "node/4235760489"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3879197,
                    27.6831711
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243030035",
            "properties": {
                "addr:city": "Madyapur Thimi 3",
                "addr:street": "Kausaltar",
                "amenity": "bank",
                "name": "prabhu bank",
                "opening_hours": "9:00 - 15:00",
                "operator": "private",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/4243030035"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3651955,
                    27.674693
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243040929",
            "properties": {
                "addr:street": "Shankhadar Chowk",
                "amenity": "bank",
                "name": "Prabhu Bank",
                "id": "node/4243040929"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3854613,
                    27.6735172
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4264060430",
            "properties": {
                "amenity": "bank",
                "name": "Apex Development bank Ltd.",
                "id": "node/4264060430"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3605678,
                    27.6745055
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4275939289",
            "properties": {
                "amenity": "bank",
                "name": "Machhapuchre bank",
                "id": "node/4275939289"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3825788,
                    27.6731536
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4394344089",
            "properties": {
                "amenity": "bank",
                "name": "Araniko Co-operative",
                "opening_hours": "Su-Fr 10:00-17:00",
                "id": "node/4394344089"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730815,
                    27.6729536
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4394927094",
            "properties": {
                "amenity": "bank",
                "name:en": "Araniko Co-operative",
                "opening_hours": "Su-Fr 10:00-17:00",
                "id": "node/4394927094"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730774,
                    27.6729401
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4417866492",
            "properties": {
                "amenity": "bank",
                "name:en": "Araniko Co-operative",
                "id": "node/4417866492"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730623,
                    27.6729396
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4432060781",
            "properties": {
                "amenity": "bank",
                "atm": "yes",
                "name": "Thibodin Bachat Tatha Rin Sahakari Sanstha",
                "phone": "016639542",
                "id": "node/4432060781"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3887172,
                    27.6898086
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4470655791",
            "properties": {
                "amenity": "bank",
                "name:en": "NUBL Chaling Sakha",
                "id": "node/4470655791"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4705689,
                    27.7037567
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4497805093",
            "properties": {
                "addr:postcode": "44811",
                "addr:street": "Madhyapur Thimi - 7, Bahakha Bazar",
                "amenity": "bank",
                "name:en": "Citizens Bank International Limited",
                "opening_hours": "Su-Fr 10:00-05:00",
                "phone": "016636535",
                "id": "node/4497805093"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3879323,
                    27.6831307
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4512983190",
            "properties": {
                "addr:housenumber": "1",
                "addr:street": "tumacho",
                "amenity": "bank",
                "name:en": "Bhaktapur bachat",
                "opening_hours": "Su-Fr 10:00-22:00",
                "id": "node/4512983190"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4392389,
                    27.6745371
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4529393889",
            "properties": {
                "addr:housenumber": "100",
                "addr:postcode": "44800",
                "addr:street": "Arniko Raj Marga",
                "amenity": "bank",
                "name:en": "Gurkhas Finance",
                "id": "node/4529393889"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4263609,
                    27.6653502
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4559353392",
            "properties": {
                "addr:city": "Madhyapur Thimi Municipality",
                "addr:place": "Bahakha bazar - 6",
                "addr:postcode": "44811",
                "addr:street": "Bode marga",
                "amenity": "bank",
                "name": "Nepal Credit & Commercial Ltd",
                "opening_hours": "Su-Fr 10:00-16:00",
                "operator": "Private",
                "id": "node/4559353392"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3874924,
                    27.6834748
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4559353790",
            "properties": {
                "addr:city": "Madhyapur Thimi Municipality",
                "addr:place": "Bahakha bazar - 6",
                "addr:postcode": "44811",
                "addr:street": "Bode marga",
                "amenity": "bank",
                "name:en": "Mega Bank Limited",
                "opening_hours": "Su-Fr 10:00-16:00",
                "operator": "Private",
                "id": "node/4559353790"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3873534,
                    27.683341
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4559360892",
            "properties": {
                "addr:postcode": "44811",
                "addr:street": "Madhyapur Thimi - 7, Hulak Road",
                "amenity": "bank",
                "name:en": "Swastik saving & Credit Co-operative Limited",
                "opening_hours": "Su-Fr 10:00-15:00",
                "phone": "016633067",
                "id": "node/4559360892"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3901322,
                    27.6835816
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4728706590",
            "properties": {
                "amenity": "bank",
                "name:en": "Nepal Bank",
                "id": "node/4728706590"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3865489,
                    27.6731341
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4820611885",
            "properties": {
                "addr:street": "Araniko Raj Marga",
                "amenity": "bank",
                "name": "Himalayan Bank Limited",
                "name:en": "Himalayan Bank",
                "phone": "01-4250201",
                "website": "https://www.himalayanbank.com",
                "wheelchair": "no",
                "id": "node/4820611885"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3693288,
                    27.6745583
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4936281426",
            "properties": {
                "addr:street": "Bhaktapur",
                "amenity": "bank",
                "name:en": "Everest Bank",
                "id": "node/4936281426"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4231039,
                    27.6657054
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5267586121",
            "properties": {
                "amenity": "bank",
                "name": "Nepal investment bank",
                "name:en": "Nepal investment bank",
                "id": "node/5267586121"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3648344,
                    27.6742201
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5283018922",
            "properties": {
                "amenity": "bank",
                "name:en": "Om Development Bank Bhaktapur",
                "id": "node/5283018922"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4318493,
                    27.6724382
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5687407621",
            "properties": {
                "amenity": "bank",
                "name:en": "Siddhartha Bank",
                "wheelchair": "no",
                "id": "node/5687407621"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730439,
                    27.6741436
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5796473656",
            "properties": {
                "addr:postcode": "+977",
                "addr:street": "Ghalate",
                "amenity": "bank",
                "email": "katunjecooperativeltd@gmail.com",
                "name:en": "Katunje Sahakari Ltd",
                "operator": "Katunje Sahakari Ltd",
                "phone": "015092214",
                "id": "node/5796473656"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4221984,
                    27.6656883
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064240609",
            "properties": {
                "amenity": "bank",
                "name": "Nabil Bank Kaushaltar",
                "wheelchair": "no",
                "id": "node/6064240609"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3634122,
                    27.674311
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064240610",
            "properties": {
                "amenity": "bank",
                "name": "Nabil Bank Limited",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6064240610"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3644375,
                    27.6742593
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064240611",
            "properties": {
                "amenity": "bank",
                "name": "Laxmi Bank Limited",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/6064240611"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3686594,
                    27.6745077
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064309355",
            "properties": {
                "amenity": "bank",
                "name": "Siddharth Bank Limited",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6064309355"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3727947,
                    27.6742337
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064309357",
            "properties": {
                "amenity": "bank",
                "name": "Prime Bank Limited",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6064309357"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3747215,
                    27.6735744
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065286049",
            "properties": {
                "amenity": "bank",
                "name": "Sumeru saving and credit cooperative ltd",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6065286049"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3759,
                    27.6728516
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065420352",
            "properties": {
                "amenity": "bank",
                "name": "Nepal Investment Bank Limited",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065420352"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3653105,
                    27.6724913
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6789566385",
            "properties": {
                "addr:street": "Binayak Marga",
                "amenity": "bank",
                "name:en": "Himalayan Saving & Credit Co Operative",
                "opening_hours": "Su-Fr 09:00-18:00",
                "phone": "015092803",
                "id": "node/6789566385"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4258088,
                    27.664277
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/7175505587",
            "properties": {
                "addr:street": "Prabhat school",
                "amenity": "bank",
                "name:en": "Kumari bank",
                "id": "node/7175505587"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4304537,
                    27.6756113
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/7176386291",
            "properties": {
                "amenity": "bank",
                "name:en": "Vintuna sacos",
                "id": "node/7176386291"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4292533,
                    27.6744711
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/7375081095",
            "properties": {
                "amenity": "bank",
                "email": "abhiyaansaccos@gmail.com",
                "name:en": "Abhiyan Saccos अभियान साकाेस",
                "phone": "016610146",
                "id": "node/7375081095"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.437252,
                    27.675744
                ]
            }
        }
    ]
}
